import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

export default function StatItemTwo() {
    return (
        <Box
            width="100%"
            sx={{
                background: '#6b0000',
                display: 'grid',
                placeItems: 'center',
                py: 10,
            }}
        >
            <Grid container maxWidth="lg" justifyContent="center" sx={{ px: 2 }}>
                <Grid item xs={12} md={8} textAlign="center">
                    <Typography
                        variant="h2"
                        color="grey.100"
                        fontWeight="bold"
                        sx={{ fontSize: { xs: '3.5rem', md: '6rem' }, lineHeight: 1, mb: 2 }}
                    >
                        82%
                    </Typography>
                    <Typography variant="h4" color="grey.200" fontWeight="bold" mb={2}>
                        of breaches involved data stored in the cloud — public, private,
                        or across multiple environments.
                    </Typography>
                    <Typography variant="body1" color="grey.400" sx={{ fontStyle: 'italic' }}>
                        IBM Cost of a Data Breach Report
                    </Typography>
                    <Box
                        sx={{
                            width: 60,
                            height: 4,
                            background: 'rgba(255,255,255,0.3)',
                            mx: 'auto',
                            mt: 4,
                            borderRadius: 2,
                        }}
                    />
                </Grid>
            </Grid>
        </Box>
    );
}
